import { useAuth } from 'hooks/auth';
import Profile from "assets/icons/profile.svg";
import editDisabledSvg from "assets/icons/edit-disabled.svg";

import * as S from './styles';

export function CardResponsible() {
  const { user } = useAuth();

  return (
    <>
    <S.Label>Responsável pela execução*</S.Label>
    <S.Container>
      <div className='responsible-card'>
        <img
          className='icon'
          src={Profile}
          alt="Imagem de icone de perfil"
        />
        <S.Content>
          <p className="responsible-name">{user.name}</p>
        </S.Content>
      </div>
      <div className='edit-button'>
         <img className='icon' src={editDisabledSvg} alt="Imagem de lápis para editar" />
      </div>
    </S.Container>
    </>
  );
}
